<script>
// @ts-check

import * as _ from 'lodash-es'
import { h, useAttrs } from 'vue'

export default {
  name: 'BaseIcon',
  props: {
    /**
     * Name of the SVG icon in the "assets/icons" folder without the file
     * extension. E.g. if you want to use the icon "assets/icons/info.svg",
     * pass "info" as the name prop.
     */
    name: {
      type: String,
      default: null
    },
    /**
     * Direct path to the SVG file
     */
    svg: {
      type: String,
      default: null
    },
    /**
     * Use this prop for a smaller icon
     */
    small: {
      type: Boolean
    },
    /**
     * Use this prop for a larger icon
     */
    large: {
      type: Boolean
    },
    /**
     * Use this prop to disable automatic height/width classes from getting
     * applied to the icon
     */
    customSize: {
      type: Boolean
    },
    illustration: {
      type: Boolean
    }
  },
  setup(props) {
    const attrs = useAttrs()

    return () => {
      let svgHtml = null

      // Use svg prop as file path
      if (props.svg) {
        svgHtml = props.svg
      } else {
        if (!props.name) {
          return null
        }

        svgHtml = props.illustration
          ? require(`@/assets/illustrations/${props.name}.svg?inline`)
          : require(`@/assets/icons/${props.name}.svg?inline`)
      }

      // Programmatically create an actual SVG dom element out of the SVG HTML
      // string so that we can access the attributes and content without any
      // sort of regex spaghetti. 🍝

      const div = document.createElement('div')
      div.innerHTML = svgHtml
      const fragment = document.createDocumentFragment()
      fragment.appendChild(div)
      const svg = fragment.querySelector('svg')

      // Get attributes from the SVG as an object so we can pass them to h()
      let svgAttrs = {}

      if (Object.fromEntries) {
        svgAttrs = Object.fromEntries(
          [...svg.attributes].map((attr) => [attr.name, attr.value])
        )
      }

      // Define icon size
      let sizeClass = ''
      if (!props.customSize) {
        sizeClass = 'w-4 min-w-4 h-4'
        sizeClass = props.small ? 'w-3 min-w-3 h-3' : sizeClass
        sizeClass = props.large ? 'w-5 min-w-5 h-5' : sizeClass
      }

      // Compose icon class string
      const staticClass = `inline-block fill-current leading-none ${
        sizeClass || ''
      }`

      const attributes = _.omit(attrs, ['class'])

      return h('svg', {
        ...svgAttrs,
        innerHTML: svg.innerHTML,
        class: [staticClass],
        role: 'img',
        focusable: 'false',
        title: props.name,
        ...attributes
      })
    }
  }
}
</script>
